import React from "react";
import PdfBase from "./PdfBase";
import { generateAllocationExpensesPdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  incomeRows,
  statutoryExpensesRows,
  commonExpensesRows,
  cappedRate,
  expenseCappedAmount,
  cappedVsCommon,
  finalAllowedExpenses,
  deductibleAllocationRows,
  totalDeductibleExpenses,
  notes,
  reviewNotes
}) => {
  const sharedArgs = [
    schedule,
    company,
    incomeRows,
    statutoryExpensesRows,
    commonExpensesRows,
    cappedRate,
    expenseCappedAmount,
    cappedVsCommon,
    finalAllowedExpenses,
    deductibleAllocationRows,
    totalDeductibleExpenses,
    notes,
    reviewNotes
  ];

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateAllocationExpensesPdf(forView, ...sharedArgs)
        }
        downloadName='Allocation of Expenses Schedule'
      />

      <ExcelBase
        generateExcel={(forView) =>
          generateAllocationExpensesPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
